import Check from '@/components/Check';
import Tooltip from '@/components/Tooltip';
import buyCertificationLink from '@/domain/buyCertificationLink';
import { CertificationNumberDivider } from './CertificationNumber';

function CertificationCardItem({ label, value }) {
  return (
    <div className="flex items-center space-x-4 lg:h-8">
      <h4 className="text-base font-semibold leading-5 text-gray-800 lg:text-lg">
        {label}
      </h4>
      <CertificationNumberDivider />
      <div>{value}</div>
    </div>
  );
}

export default function CertificationCard({ info }) {
  const hasProduct = info.product !== null;
  const hasPrice = hasProduct && info.product.price !== null;
  const hasExam =
    info.certificacionWithExam !== null && info.certificacionWithExam === true;
  const hasTraining = info.training !== null;
  const hasAcclaimBadge = info.aacclaim !== null;

  return (
    <div className="rounded-lg bg-white shadow-lg lg:rounded-xl xl:rounded-2xl">
      <div className="rounded-lg lg:rounded-xl xl:rounded-2xl">
        <div className="w-full space-y-2 px-5 py-4 lg:space-y-0 lg:p-6">
          {hasPrice && (
            <CertificationCardItem
              label="Inversión"
              value={
                <div className="text-lg font-semibold text-green-500 lg:text-xl xl:text-2xl xl:font-medium">
                  {info.product.price}
                </div>
              }
            />
          )}
          {hasExam && (
            <CertificationCardItem
              label="Realiza examen"
              value={
                <Tooltip tooltip="Sí">
                  <button
                    className="block text-green-400 hover:text-green-600 focus:outline-none"
                    type="button"
                  >
                    <Check />
                  </button>
                </Tooltip>
              }
            />
          )}
          {hasTraining && (
            <CertificationCardItem
              label="Entrenamiento"
              value={
                <Tooltip tooltip={info.training.title}>
                  <button
                    className="block text-green-400 hover:text-green-600 focus:outline-none"
                    type="button"
                  >
                    <Check />
                  </button>
                </Tooltip>
              }
            />
          )}
          {hasAcclaimBadge && (
            <CertificationCardItem
              label="Insignia digital verificada"
              value={
                <Tooltip tooltip="Validado por Credly">
                  <button
                    className="block text-green-400 hover:text-green-600 focus:outline-none"
                    type="button"
                  >
                    <Check />
                  </button>
                </Tooltip>
              }
            />
          )}
        </div>
        <div className="flex items-center justify-end rounded-b-xl bg-gray-100 px-5 py-4">
          {hasProduct && (
            <a
              href={buyCertificationLink(info.product.databaseId)}
              className="block w-full rounded-full bg-green-500 px-6 py-2 text-center text-base font-semibold leading-5 text-white hover:bg-green-600 focus:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 lg:py-3 lg:text-lg lg:leading-6"
              role="button"
            >
              Certifícate hoy mismo
            </a>
          )}
          {!hasProduct && (
            <div className="flex w-full items-center justify-center space-x-2">
              <svg
                className="h-4 w-4 text-red-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              <div className="flex-1 text-sm font-normal text-gray-600">
                Certificación no disponible en línea
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
